module.exports = __webpack_public_path__ + "static/media/welcometitle.26f28f5a.png";